var requiredJSLoaded = false;

namespace Pages._Camera.Player.Test.Period {

    export function onDocumentReady() {

        let defaultDate = Date.today().addDays(-5);

        let controlDiv = $("<div style='display:none'>");

        let prodDiv = $(`<div style='margin-bottom:10px;display:inline-block;'><span style='width:100px;display:inline-block;'>ProductID&nbsp;</span></div>`);
        let prodTxt = $(`<input type='text' class='camera-request-productid' value='301' />`);
        prodDiv.append(prodTxt);
        controlDiv.append(prodDiv);

        let regDiv = $(`<div style='margin-bottom:10px;'><span style='width:100px;display:inline-block;'>Registration&nbsp;</span></div>`);
        let regTxt = $(`<input type='text' class='camera-request-registration' />`);
        regDiv.append(regTxt);
        controlDiv.append(regDiv);

        let datetimeDiv = $("<div>");
        let datePkr = $(`<input type='text' class='camera-request-date' value='${defaultDate.format("dd/MM/yyyy", 0)}' style='margin-bottom:10px;' />`);
        datetimeDiv.append("<span style='width:100px;display:inline-block;'>Date&nbsp;</span>", datePkr, "<br/><span style='width:100px;display:inline-block;'>Time&nbsp;</span>");
        let fromTimePkr = new CDN.Controls.UI.DateTime.TimePicker(datetimeDiv.get(0), {
            hour: {
                value: 4,
            },
            minute: {
                value: 25,
            },
            second: {
                show: false,
            }
        });

        let toTimePkr = new CDN.Controls.UI.DateTime.TimePicker(datetimeDiv.get(0), {
            hour: {
                value: 5,
            },
            minute: {
                value: 7,
            },
            second: {
                show: false,
            }
        });

        let fetchBtn = $(`<button>Fetch</button>`);


        let fromDt = new Date(defaultDate);
        let toDt = new Date(defaultDate);
        let task = "latest";

        let groupController: CDN.Camera.GroupController;

        datePkr.datepicker({
            dateFormat: 'dd/mm/yy',
            onSelect: (dateText: string, inst: any) => {
                let dateComponents = dateText.split("/").map(dc => parseInt(dc));
                fromDt = new Date(dateComponents[2], dateComponents[1] - 1, dateComponents[0]);
            }
        });


        let fetchFn = () => {
            let date: Date = datePkr.datepicker("getDate");
            for (let player of CDN.Camera.Player.CameraPlayers) {
                player.fetchFramesAsync({
                    period: {
                        from: date.getTZTime(0) + fromTimePkr.time,
                        to: date.getTZTime(0) + toTimePkr.time + 59900,
                    },
                });
            }
        };

        fetchBtn.click(e => {
            e.preventDefault();
            e.stopPropagation();

            fetchFn();
        });

        controlDiv.append(prodDiv, regDiv, datetimeDiv, fetchBtn);

        $("body").append(controlDiv);

        let lightDiv = $("<div style='padding: 20px;'>");
        $("body").append(lightDiv);

        let login = new CDN.Controls.Login(document.body, {
            onError: (err) => {
                console.error(err);
            },
            onLogin: (result) => {
                controlDiv.show();
                login.hide();
                regTxt.autocomplete({
                    source: function (request, response) {
                        CDN.API.AutoComplete.v1.searchVehiclesAsync({
                            productId: prodTxt.val(),
                            userToken: result.UserToken,
                        }, regTxt.val()).then(success => {
                            response($.map(success, function (item) {
                                return {
                                    label: item.Registration,
                                    vehicleId: item.VehicleId,
                                    registration: item.Registration,
                                    fleetNum: item.Fleetnum,
                                    product: "",
                                    productid: prodTxt.val(),
                                    usertoken: result.UserToken,
                                    departId: item.DepartId,
                                    depotId: item.DepotId,
                                };
                            }));
                        }, err => {
                        });
                    },
                    minLength: 3,
                    open: function () { $(this).removeClass("ui-corner-all").addClass("ui-corner-top"); },
                    select: function (event, ui) {
                        let registration = ui.item.value;
                        let vehicleId = ui.item.vehicleId;
                        let fleetNum = ui.item.fleetNum;

                        lightDiv.empty();
                        groupController?.destroy();

                        let controllerDiv = $("<div>");
                        lightDiv.append(controllerDiv);
                        groupController = new CDN.Camera.GroupController(controllerDiv.get(0), {
                            groupName: "Test Players",
                        });

                        CDN.API.Camera.Player.v1.getActiveVehicleCamerasAsync({
                            productId: prodTxt.val(),
                            userToken: result.UserToken,
                        }, vehicleId).then(cameras => {
                            for (let camera of cameras) {
                                let camDiv = $("<div style='display:inline-block'>");
                                let lightCameraPlayer = new CDN.Camera.Player(camDiv, {
                                    productId: prodTxt.val(),
                                    userToken: result.UserToken,
                                }, camera,
                                    {
                                        timeZone: 0,
                                        showControls: false,
                                        showPlayBackBar: false,
                                        groupController: groupController,
                                    });

                                lightDiv.append(camDiv);
                            }

                            /*lightDiv.append("<div style='height:1200px;width:100%;background-color:#EEEEEE;display:block;'></div>");*/
                        });
                    },
                    close: function () { $(this).removeClass("ui-corner-top").addClass("ui-corner-all"); }
                });
            },
        });
    }
}

CDN.requireOnce([
    { code: CDN.PackageCode.JQuery, },
    { code: CDN.PackageCode.JQuery_UI, },
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.API_AutoComplete_v1, },
    { code: CDN.PackageCode.Control_Login, },
    { code: CDN.PackageCode.Control_UI_TimePicker, },
    { code: CDN.PackageCode.Camera_Player, },
], () => {
    requiredJSLoaded = true;
    $(document).ready(Pages._Camera.Player.Test.Period.onDocumentReady);
});